import { z, type ZodError, type ZodObject, type ZodRawShape } from "zod/v4";

const localeMap = {
  fr: () => import("zod/v4/locales/fr.js"),
  en: () => import("zod/v4/locales/en.js"),
};

const loadLocale = async (language?: keyof typeof localeMap) => {
  const localeLoader = localeMap[language ?? "en"];
  const { default: locale } = await localeLoader();
  z.config(locale());
};

export { z, loadLocale };
export type { ZodError, ZodObject, ZodRawShape };
